module.exports = "<div class=\"greyBg\">\n  <div class=\"start\">\n    <div class=\"container\">\n      <a class=\"navbar-brand\">\n        <img alt=\"Brand\" src=\"/assets/images/logo.png\">\n      </a>\n      <div class=\"clear\"></div>\n      <div class=\"container-box\">\n        <router-outlet></router-outlet>\n        <div class=\"clear\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/intro-wizard/intro-wizard.component.html
// module id = 1424
// module chunks = 7